import React, { useContext } from 'react';
import { Input } from 'antd';

import ZoneMappingContext from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingContext';

const ZoneSearch = () => {
  const { input, setInput } = useContext(ZoneMappingContext);

  return (
    <Input
      width={'250px'}
      value={input.searchTerm}
      onChange={(evt) => setInput({ searchTerm: evt.target.value })}
    />
  );
};

export default ZoneSearch;
